import { Key, RefreshCw, Server } from 'lucide-react';
import React from 'react';
import { gameOptions, serverOptions } from '../consts';

const AuthForm = ({ authConfig, setAuthConfig, runFullAuth, loading, onGameChange }) => {
  return (
    <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-lg">
      <div className="mb-8">
        <h1 className="mb-2 text-3xl font-bold text-gray-900">Betting Simulator - Авторизація</h1>
        <p className="text-gray-600">Крок 1: Налаштування та отримання sessionId для симуляції ставок</p>
      </div>

      <div className="p-6 mb-6 rounded-lg bg-gray-50">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-900">Конфігурація авторизації</h2>
        </div>

        <div className="grid gap-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              <Server className="inline w-4 h-4 mr-1" />
              Сервер
            </label>
            <select
              value={authConfig.server}
              onChange={(e) => setAuthConfig((prev) => ({ ...prev, server: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {serverOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Гра</label>
            <select
              value={authConfig.gameId}
              onChange={(e) => {
                const newGameId = e.target.value;
                setAuthConfig((prev) => ({ ...prev, gameId: newGameId }));
                if (onGameChange && newGameId !== authConfig.gameId) {
                  onGameChange(newGameId);
                }
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {gameOptions.map((game) => (
                <option key={game.value} value={game.value}>
                  {game.title}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <button
          onClick={runFullAuth}
          disabled={loading.getToken || loading.getAuth}
          className="flex items-center justify-center w-full gap-2 px-6 py-3 font-semibold text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-blue-400"
        >
          {loading.getToken || loading.getAuth ? (
            <RefreshCw className="w-5 h-5 animate-spin" />
          ) : (
            <Key className="w-5 h-5" />
          )}
          {loading.getToken || loading.getAuth ? 'Проходження авторизації...' : 'Пройти авторизацію'}
        </button>
      </div>
    </div>
  );
};

export default AuthForm;
